export default "__VITE_ASSET__11d179c7__"